<!--
* UIID: 
* UI Name: Deploy User Component
* Modify Date: 2022/08/15
-->
<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    class="dialog-drag-display add-map-layout-dialog custom-add-map-layout-dialog"
  >
    <template v-slot:title>
      <!-- [S]  Popup title-->
      <v-card-title class="headline white--text" primary-title>
        {{ $t('lbl.userSimulator.deployUserComp.title') }}
      </v-card-title>
    </template>
    <template v-slot:button-close>
      <v-btn small text icon @click="removeDialog">
        <icon-svg iconName="close" />
      </v-btn>
    </template>
    <v-card class="dialog-container">
      <!-- [S]  Popup body-->
      <v-card-text class="pb-0">
        <v-form ref="form" class="dialog-content">
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="3">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.userSimulator.deployUserComp.userComp') }}
              </span>
            </v-col>
            <v-col lg="9" class="map-text-field pl-0">
              <v-text-field
                v-if="options.item.action !== 'usercompsim'"
                v-model="userCompName"
                :rules="[validationUtils.required]"
                class="data-table-filter-text-field inline-block-component text-field-flatfile-layout map-name-textfield"
                ref="refMapName"
                heigth="30"
                outlined
                dense
                solo
              ></v-text-field>
              <v-select
                v-if="options.item.action == 'usercompsim'"
                v-model="userCompName"
                :items="userCompList"
                @change="changeUserComp()"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                ref="refType"
                height="30"
                dense
                solo
                outlined
              ></v-select>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="3">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.userComponent.scriptFile') }}
              </span>
            </v-col>
            <v-col lg="9" class="map-text-field inline-block-component pl-0">
              <v-text-field
                v-model="selectedUserComp.uc_file_name"
                :rules="[validationUtils.required]"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                ref="refFileName"
                height="30"
                dense
                solo
                outlined
                readonly
              ></v-text-field>
              <input
                @change="onFileChanged"
                id="edifile"
                type="file"
                ref="edifile"
                style="display: none"
              />
              <v-btn
                class="btn btn-search scanner-load-btn"
                color="primary"
                @click="openLoadFilePop({ mode: 'Load', filetype: 'script' })"
              >
                {{ $t('btn.common.load') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row class="ml-0 mr-0">
            <v-col class="required-col field-col" lg="3">
              <v-icon x-small>fas fa-asterisk</v-icon>
              <span class="field-label required-text">
                {{ $t('lbl.dbMapperTest.deployDBMapper.comment') }}
              </span>
            </v-col>
            <v-col lg="9" class="map-text-field pl-0">
              <v-text-field
                v-model="comment"
                class="data-table-select-box srm-select-box custom-selectbox flatfile-layout-selectbox communication-select-box pt-0 pl-select"
                ref="refComment"
                height="30"
                dense
                solo
                outlined
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
        <v-divider class="ml-0 mr-0 divder-popup" inset></v-divider>
        <v-row class="ml-0 mr-0">
          <v-col class="button-col action-col" lg="12">
            <div class="btn-form-control text-right mr-4">
              <v-btn class="btn btn-delete" @click="removeDialog">
                {{ $t('btn.common.close') }}
              </v-btn>
              <v-btn class="btn btn-popup-search" @click="deploy" color="primary">
                {{ $t('btn.userSimulator.deploy') }}
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{
            $t('lbl.referenceFiles.addReferenceFile.viewPdfFile')
          }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark>
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card>
    </v-dialog>
    <dialogWindow
      ref="successDialog"
      size="max"
      title="Success"
      color="success"
      @select-ok="removeDialog"
      :detail="$t('msg.userSimulator.deployUserComp.deploySuccess')"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';

export default {
  components: {
    DialogDrag,
    IconSvg,
    dialogWindow,
  },
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
  },
  data() {
    return {
      userCompName: '',
      userCompResponse: [],
      userCompList: [],
      selectedUserComp: '',
      comment: '',
      fileName: '',
      fileId: '',
    };
  },
  methods: {
    deploy() {
      let validResult = this.$refs.form.validate();
      this.selectedUserComp.uc_file_comment = this.comment;
      if (validResult) {
        this.$store.dispatch('userComponentCheckIn', this.selectedUserComp).then(() => {
          this.$refs.successDialog.dialog = true;
        });
      }
    },
    changeUserComp() {
      let index = this.userCompResponse.findIndex((item) => {
        return item.uc_name == this.userCompName;
      });
      this.selectedUserComp = this.userCompResponse[index];
      console.log(this.selectedUserComp);
    },
    onFileChanged(e) {
      console.log(e);
      this.selectedUserComp.file_id = e[0].FILE_ID;
      this.selectedUserComp.uc_file_name = e[0].FILE_NAME;
      this.selectedUserComp.file_content = e[0].FILE_CONTENT;
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      let callback = (row) => {
        Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {});
      };
      this.$emit('openLoadFile', {
        mode: 'Load',
        filetype: filetype,
        lastFoldIdInput: this.lastFoldIdInput,
        lastFoldIdScript: this.lastFoldIdScript,
        callback,
      });
    },
    removeDialog(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
  created() {
    this.selectedUserComp = this.options.item.data;
    this.selectedUserComp.uc_file_name = this.selectedUserComp.file_name;
    this.userCompName = this.selectedUserComp.uc_name;
    this.$store.dispatch('getUserSimQueryList', { lock_yn: 'y' }).then(() => {
      this.userCompResponse = this.$store.getters.userSimList;
      for (let i = 0; i < this.userCompResponse.length; i++) {
        let text = this.userCompResponse[i].uc_name;
        this.userCompList.push(text);
      }
    });
  },
};
</script>

<style></style>
